const HeroCarouselCard = {
  init: function (element) {
    this.element = element;

    this.configureMediaControls.bind(this)();
  },

  configureMediaControls: function () {
    const arrMediaWrapper = this.element.querySelectorAll('.hero-carousel-card__bg-media--video');

    for (const element of arrMediaWrapper) {

        const playButton = element.querySelector('.hero-carousel__button-play');
        const pauseButton = element.querySelector('.hero-carousel__button-pause');
        const controlsWrapper = element.querySelector('.hero-carousel__video-controls');
        const video = element.querySelector('iframe');

        playButton?.addEventListener('click', () => {
          this.videoToggle(video, 'play');
          controlsWrapper.classList.add('playing');
        })

        pauseButton?.addEventListener('click', () => {
          this.videoToggle(video, 'pause');
          controlsWrapper.classList.remove('playing');
        })
      
      }
  },

  videoToggle: function (video, action) {
    const data = { method: action };
    const url = video.src.split('?')[0];

    if (url !== undefined) {
      video.contentWindow.postMessage(JSON.stringify(data), url);
    }
  }

};

export default HeroCarouselCard;
